export default __webpack_public_path__ + "static/media/ss.f0c05ecb.jpg";